{
  "同一个抛掷，四个引擎 · 物理AI实验室 Lab 1.4": {
    "en": "One throw, four engines · Physical AI Lab 1.4",
    "ja": "同じ投てき、四つのエンジン · Physical AI Lab 1.4"
  },
  "同一个抛掷，四个引擎": {
    "en": "One throw, four engines",
    "ja": "同じ投てき、四つのエンジン"
  },
  "同一个盒子、同样的质量和摩擦、同样的出手速度。落地之前，四条轨迹几乎重合；<span style=\"color:var(--l3)\">碰到地面那一下</span>，它们就分开了。": {
    "en": "Same box, mass, friction and throw. In the air the four paths nearly coincide; <span style=\"color:var(--l3)\">on impact</span>, they split apart.",
    "ja": "同じ箱、同じ質量と摩擦、同じ投げ方。着地するまで四本の軌跡はほぼ重なります。<span style=\"color:var(--l3)\">地面に当たった瞬間</span>、ばらばらになります。"
  },
  "离四引擎平均位置的距离": {
    "en": "Distance from the four-engine mean",
    "ja": "四つのエンジンの平均位置からの距離"
  },
  "仿真时间": {
    "en": "Sim time",
    "ja": "シミュレーション時間"
  },
  "播放（0.25 倍速）": {
    "en": "Play (0.25× speed)",
    "ja": "再生（0.25倍速）"
  },
  "拖仿真时间 · 拖动空白处旋转视角": {
    "en": "Drag the sim time · drag empty space to orbit",
    "ja": "時間をドラッグ · 空いた所をドラッグして視点を回す"
  },
  "引擎": {
    "en": "Engine",
    "ja": "エンジン"
  },
  "最深穿透": {
    "en": "Max penetration",
    "ja": "最大めり込み"
  },
  "离平均": {
    "en": "Off the mean",
    "ja": "平均からのずれ"
  },
  "盒子 {0}×{1}×{2} cm、{3} g、摩擦 {4}，从 {5} cm 高斜着抛出。": {
    "en": "A {0}×{1}×{2} cm box, {3} g, friction {4}, thrown at a slant from {5} cm up. ",
    "ja": "{0}×{1}×{2} cm、{3} g、摩擦 {4} の箱を、高さ {5} cm から斜めに投げます。"
  },
  "每个引擎用自己的默认接触设置。落地前四者相差不到 {0} cm（只是积分步长不同）；": {
    "en": "Each engine uses its own default contact settings. Before landing the four differ by under {0} cm (only the integration step differs); ",
    "ja": "各エンジンは自分の既定の接触設定を使います。着地前の差は {0} cm 未満（積分の刻み幅の違いだけ）。"
  },
  "停下时最远的两个相差 {0} cm。穿透：盒角压进地面的深度，“软”接触会先压进去再弹回。": {
    "en": "At rest the two furthest are {0} cm apart. Penetration: how deep a corner sinks into the ground; a \"soft\" contact sinks in first, then pushes back.",
    "ja": "止まったとき、最も離れた二つの差は {0} cm。めり込み：箱の角が地面に沈む深さ。「やわらかい」接触は、いったん沈んでから押し返します。"
  },
  "停下时最远的两个相差 {0} cm": {
    "en": "At rest, the two furthest are {0} cm apart",
    "ja": "停止時、最も離れた二つの差は {0} cm"
  },
  "数据：本机实跑 · ": {
    "en": "Data: run on this machine · ",
    "ja": "データ：このマシンで実行 · "
  },
  "撞地 · 压进 {0} mm": {
    "en": "impact · {0} mm deep",
    "ja": "着地 · {0} mm めり込み"
  },
  "偏 {0} cm": {
    "en": "off {0} cm",
    "ja": "ずれ {0} cm"
  },
  "空中 · 慢放": {
    "en": "In the air · slowed",
    "ja": "空中 · スロー"
  },
  "落地 · 放慢 8 倍": {
    "en": "Landing · 8× slower",
    "ja": "着地 · 8倍スロー"
  },
  "滑行、停下": {
    "en": "Sliding, stopping",
    "ja": "滑って、止まる"
  },
  "停下": {
    "en": "At rest",
    "ja": "停止"
  }
}
